import React, { useState } from 'react';

const LAP_MS = 2800;

// The startup screen lives in public/index.html and React replaces it on its
// first render, so its markup is captured while the module loads. The
// full-screen loader reuses it as-is, styles included.
const startupScreen = typeof document === 'undefined'
  ? ''
  : document.querySelector('#root > .app-shell')?.outerHTML ?? '';
let lapOrigin;

// Negative delay that keeps the kart lapping from where the startup screen
// left it instead of jumping back to the start line on every remount.
function lapPhase() {
  const now = document.timeline?.currentTime;
  if (now == null) return 0;
  if (lapOrigin === undefined) {
    const lap = document.querySelector('.app-shell__runner')?.getAnimations?.()[0];
    lapOrigin = now - (lap?.currentTime ?? 0);
  }
  return -((now - lapOrigin) % LAP_MS);
}

export default function PageLoader({ fullScreen = false }) {
  const [phase] = useState(() => (fullScreen && startupScreen ? lapPhase() : 0));

  if (fullScreen && startupScreen) {
    return <div style={{ '--app-shell-phase': `${phase}ms` }} dangerouslySetInnerHTML={{ __html: startupScreen }} />;
  }

  return (
    <div className={`flex items-center justify-center ${fullScreen ? 'min-h-screen' : 'min-h-[60vh]'}`}>
      <div
        className="w-8 h-8 rounded-full border-2 animate-spin"
        style={{ borderColor: 'var(--accent)', borderTopColor: 'transparent' }}
      />
    </div>
  );
}
